import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff230ef2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FTLBidFiles" }
const _hoisted_2 = {
  key: 1,
  class: "FTLBidFiles__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uploaded_file = _resolveComponent("uploaded-file")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.invoiceFiles.length || _ctx.certificateFiles.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.invoiceFiles.length)
            ? (_openBlock(), _createBlock(_component_uploaded_file, {
                key: 0,
                "is-visible": true,
                files: _ctx.invoiceFiles,
                title: "Файлы накладной",
                "no-delete": ""
              }, null, 8, ["files"]))
            : _createCommentVNode("", true),
          (_ctx.certificateFiles.length)
            ? (_openBlock(), _createBlock(_component_uploaded_file, {
                key: 1,
                "is-visible": true,
                files: _ctx.certificateFiles,
                title: "Сертификаты безопасности",
                "no-delete": ""
              }, null, 8, ["files"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, " Нет файлов "))
  ]))
}